import { getFirestore, doc, updateDoc } from "firebase/firestore";
import { app } from "../firebase";
import { REFERRAL_OTHER_VALUE, getReferralSourceLabel } from "../constants/ReferralSources";

const db = getFirestore(app);

export const buildReferralAnswer = ({ source, detail }) => ({
	source,
	label: getReferralSourceLabel(source),
	detail: source === REFERRAL_OTHER_VALUE ? (detail || "").trim() : "",
	answeredAt: new Date().toISOString(),
});

/**
 * Persists the "How did you hear about us?" answer and clears the pending flag.
 * Returns the fields written so callers can mirror them into local state.
 */
export const saveReferralAnswer = async (email, { source, detail }) => {
	const fields = {
		referral: buildReferralAnswer({ source, detail }),
		referralPending: false,
	};
	await updateDoc(doc(db, "users", email), fields);
	return fields;
};
